'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

exports['default'] = connectToStores;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactPureRenderComponent = require('react-pure-render/component');

var _reactPureRenderComponent2 = _interopRequireDefault(_reactPureRenderComponent);

// Default `fn` property names
// can vary on browsers
var excludedProps = Object.getOwnPropertyNames(function () {});

// borrowed from `react-redux/connect`
// https://github.com/rackt/react-redux/blob/master/src/components/connect.js#L17
function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function connectToStores() {
  for (var _len = arguments.length, connectArgs = Array(_len), _key = 0; _key < _len; _key++) {
    connectArgs[_key] = arguments[_key];
  }

  return function (DecoratedComponent) {
    var ConnectToStoresWrapper = (function (_PureComponent) {
      _inherits(ConnectToStoresWrapper, _PureComponent);

      _createClass(ConnectToStoresWrapper, null, [{
        key: 'contextTypes',
        value: { flux: _propTypes2['default'].object.isRequired },
        enumerable: true
      }, {
        key: 'displayName',
        value: 'Connect(' + getDisplayName(DecoratedComponent) + ')',
        enumerable: true
      }, {
        key: 'decoratedComponent',
        value: DecoratedComponent,
        enumerable: true
      }]);

      function ConnectToStoresWrapper(props, context) {
        var _this = this;

        _classCallCheck(this, ConnectToStoresWrapper);

        _get(Object.getPrototypeOf(ConnectToStoresWrapper.prototype), 'constructor', this).call(this, props, context);

        // if we have a reducer fn as first arg we
        // will call this fn on the full alt state

        this.handleStoresChange = function () {
          return _this.setState(_extends({}, _this.state, {
            customProps: connectArgs[connectArgs.length - 1](_this.takeSnapshot())
          }));
        };

        this.handleStoreChange = function (storeName) {
          var flux = _this.context.flux;

          return function () {
            return _this.setState(_extends({}, _this.state, {
              customProps: _extends({}, _this.state.customProps, _defineProperty({}, storeName + 'Store', flux.getStore(storeName).getState()))
            }));
          };
        };

        if (typeof connectArgs[0] === 'function') {
          this.state = {
            connectType: 'reducerFn',
            customProps: connectArgs[0](this.takeSnapshot())
          };
        } else if (typeof connectArgs[connectArgs.length - 1] === 'function') {
          // if we have a reducer fn as the last arg we
          // will call this fn on the full alt state
          this.state = {
            connectType: 'storesReducerFn',
            customProps: connectArgs[connectArgs.length - 1](this.takeSnapshot())
          };
        } else if (typeof connectArgs[0] === 'string') {
          (function () {
            // if it's string it will be stores names,
            // we want to provide the stores state into props
            var flux = _this.context.flux;

            _this.state = {
              connectType: 'storesState',
              customProps: connectArgs.reduce(function (states, storeName) {
                return _extends({}, states, _defineProperty({}, storeName + 'Store', flux.getStore(storeName).getState()));
              }, {})
            };
          })();
        }
      }

      // Copy static methods on decorated component
      // usefull is you define `onEnter` hook for `react-router`

      _createClass(ConnectToStoresWrapper, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          var _this2 = this;

          var connectType = this.state.connectType;
          var flux = this.context.flux;

          switch (connectType) {
            case 'reducerFn':
              flux.FinalStore.listen(this.handleStoresChange);
              // a store update may have been updated between state
              // initialization and listening for changes from store
              this.handleStoresChange();
              break;

            case 'storesState':
              // bind every store to a listener
              connectArgs.forEach(function (storeName) {
                var listener = _this2.handleStoreChange(storeName);
                _this2.listeners = _this2.listeners ? [].concat(_toConsumableArray(_this2.listeners), [_defineProperty({}, storeName, listener)]) : [_defineProperty({}, storeName, listener)];

                flux.getStore(storeName).listen(listener);
              });
              // same as `this.handleStoresChange()` after listening
              this.listeners.forEach(function (listenerProps) {
                var _Object$keys = Object.keys(listenerProps);

                var _Object$keys2 = _slicedToArray(_Object$keys, 1);

                var storeName = _Object$keys2[0];

                var storeListener = listenerProps[storeName];
                return storeListener();
              });
              break;

            case 'storesReducerFn':
              // bind every specified store to the handleStoresChange listener
              connectArgs.forEach(function (storeName) {
                if (typeof storeName === 'string') {
                  flux.getStore(storeName).listen(_this2.handleStoresChange);
                }
              });
              // a store update may have been updated between state
              // initialization and listening for changes from store
              this.handleStoresChange();
              break;
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          var _this3 = this;

          var connectType = this.state.connectType;
          var flux = this.context.flux;

          switch (connectType) {
            case 'reducerFn':
              flux.FinalStore.unlisten(this.handleStoresChange);
              break;

            case 'storesState':
              this.listeners.forEach(function (listenerProps) {
                var _Object$keys3 = Object.keys(listenerProps);

                var _Object$keys32 = _slicedToArray(_Object$keys3, 1);

                var storeName = _Object$keys32[0];

                var storeListener = listenerProps[storeName];
                flux.getStore(storeName).unlisten(storeListener);
              });
              this.listeners = null;
              break;

            case 'storesReducerFn':
              connectArgs.forEach(function (storeName) {
                if (typeof storeName === 'string') {
                  flux.getStore(storeName).unlisten(_this3.handleStoresChange);
                }
              });
              this.listeners = null;
              break;
          }
        }
      }, {
        key: 'takeSnapshot',
        value: function takeSnapshot() {
          var flux = this.context.flux;

          return Object.keys(flux.stores).reduce(function (obj, storeHandle) {
            var storeName = storeHandle.displayName || storeHandle;
            obj[storeName] = flux.getStore(storeName).getState();
            return obj;
          }, {});
        }
      }, {
        key: 'render',
        value: function render() {
          var customProps = this.state.customProps;

          return _react2['default'].createElement(DecoratedComponent, _extends({
            ref: DecoratedComponent.prototype.setState ? 'decorated' : undefined
          }, this.props, customProps));
        }
      }]);

      return ConnectToStoresWrapper;
    })(_reactPureRenderComponent2['default']);

    Object.getOwnPropertyNames(DecoratedComponent).forEach(function (prop) {
      // Copy only fn and not defined ones on `ConnectToStoresWrapper`
      if (excludedProps.indexOf(prop) < 0 && typeof DecoratedComponent[prop] === 'function' && !ConnectToStoresWrapper[prop]) {
        var staticMethod = DecoratedComponent[prop];
        ConnectToStoresWrapper[prop] = staticMethod;
      }
    });

    return ConnectToStoresWrapper;
  };
}

module.exports = exports['default'];



//////////////////
// WEBPACK FOOTER
// ./~/connect-alt/dist/main.js
// module id = 85
// module chunks = 0